// extracted by mini-css-extract-plugin
export var actions = "_e-4";
export var brand = "_e-3";
export var header = "_e-0";
export var headerContent = "_e-1";
export var identity = "_e-5";
export var logo = "_e-2";